export default "__VITE_ASSET__fGmSkytj__"